import { defineStore } from 'pinia';
import VoucherService from '@/service/VoucherService';

export const useVoucherStore = defineStore('voucherStore', {
  actions: {
    handleSubmit(payload, id) {
      const voucherService = new VoucherService();
      return voucherService.onSubmit(payload, id);
    },
    async handleRedeem(payload, id) {
      const voucherService = new VoucherService();
      await voucherService.onRedeem(payload, id);
    }
  }
});
